<template>
  <cart-item v-bind="forwarded">
    <template #default>
      <slot name="default" />
    </template>
    <template #end>
      <slot name="end" />
    </template>
    <template #promo="{ text }" v-if="$feature.tempShowPromoBadgeInCart">
      <span class="bg-brand-9 flex center p-1 pl-2 text-xs">
        <template v-if="!text?.includes($t.employee)">{{ $t.promo }}: </template>
        {{ text }}
        <vf-icon class="ml-1" name="info" />
      </span>
    </template>
  </cart-item>
</template>

<script lang="ts" setup>
import CartItem, { type Emits, type Props } from '#commerce/components/cart/item/Item.vue'

const props = defineProps<Props>()
const emits = defineEmits<Emits>()
const forwarded = useForwardPropsEmits(props, emits)

const config = useAppConfig().pages.cart

const { $feature, $t } = useNuxtApp()

if ($feature.tempShowPromoBadgeInCart) {
  config.brandClasses.promosWrapper = 'md:max-w-64 space-y-4'
  config.showItemLevelBonus = true
}
</script>
